import styled from 'styled-components';

import { CHART_LABEL_COLOR, WHITE } from '../../../utils/colors';

export const Label = styled.text`
  fill: ${CHART_LABEL_COLOR};
  font-size: 0.51em;
  font-family: sans-serif;
  alignment-baseline: middle;
`;

export const OutlinePath = styled.path`
  fill: ${WHITE};
`;
